import React from "react";
import { Link } from "react-router-dom";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { all_routes } from "../../router/all_routes";
import CollapseHeader from "../../../core/common/collapse-header";
import { checkPermission } from "../../../core/permissons/CheckPermissons"; // Adjust path as needed

const ConnectedApps = () => {
  const route = all_routes;

  // Define navigation items with permissions
  const navItems = [
    { label: "Administration", icon: "ti ti-settings-cog", link: route.location, permission: "ADMINISTRATION_ACCESS" },
    { label: "Vehicle Management", icon: "ti-car", link: route.companySettings, permission: "VEHICLE_MANAGER_ACCESS" },
    { label: "Key Management", icon: "ti-apps", link: route.invoiceSettings, permission: "KEY_MANAGER_ACCESS" },
    { label: "Visitor Management", icon: "ti ti-device-laptop", link: route.floorplanCanvas, permission: "VISITOR_MANAGER_ACCESS" },
    { label: "Facility Management", icon: "ti ti-moneybag", link: route.maintenanceTasksDashboard, permission: "FACULTY_MAINTENANCE_ACCESS" },
    { label: "Letter Management", icon: "ti ti-flag-cog", link: route.letter, permission: "LETTER_REGISTRATION_ACCESS" },
  ];

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              {/* Page Header */}
              <div className="page-header">
                <div className="row align-items-center">
                  <div className="col-8">
                    <h4 className="page-title">Settings</h4>
                  </div>
                  <div className="col-4 text-end">
                    <div className="head-icons">
                      <CollapseHeader />
                    </div>
                  </div>
                </div>
              </div>
              {/* /Page Header */}
              {/* Settings Menu */}
              <div className="card">
                <div className="card-body pb-0 pt-2">
                  <ul className="nav nav-tabs nav-tabs-bottom">
                    {navItems.map((item, index) => (
                      item.permission && checkPermission(item.permission) && (
                        <li className="nav-item me-3" key={index}>
                          <Link
                            to={item.link}
                            className={`nav-link px-0 ${index === 0 ? "active" : ""}`} // First item as active by default
                          >
                            <i className={item.icon} /> {item.label}
                          </Link>
                        </li>
                      )
                    ))}
                  </ul>
                </div>
              </div>
              {/* /Settings Menu */}
            </div>
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}
    </>
  );
};

export default ConnectedApps;